import Vue from 'vue';
import Vuex from 'vuex';
// import VuexPersistence from 'vuex-persist';
import { shgcWindowData } from './shgcWindowData';
import { defaultSchema, defaultProject, defaultShadings } from './default';
Vue.use(Vuex);

// const vuexLocal = new VuexPersistence({
//   key: 'vuex',
//   storage: window.localStorage,
//   // reducer: state => ({
//   //   projects: state.projects,
//   // }),
// });

const storedProjects = localStorage.getItem('projects');
const storedShadings = localStorage.getItem('shadings');

export default new Vuex.Store({
  state: {
    schema: JSON.parse(JSON.stringify(defaultSchema)),
    projects: storedProjects ? JSON.parse(storedProjects) : [JSON.parse(JSON.stringify(defaultProject))],
    activeProject: '',
    shgcWindowData: shgcWindowData,
    shadings: storedShadings ? JSON.parse(storedShadings) : JSON.parse(JSON.stringify(defaultShadings)),
  },
  mutations: {
    setSchema: (state, schema) => {
      state.schema = JSON.parse(JSON.stringify(schema));
    },
    setProjects: (state, projects) => {
      state.projects = JSON.parse(JSON.stringify(projects));
    },
    setActiveProject: (state, activeProject) => {
      state.activeProject = activeProject;
    },
    setShadings: (state, shadings) => {
      state.shadings = JSON.parse(JSON.stringify(shadings));
    },

    // setAreaFloorPlate: (state, areaFloorPlate) => {
    //   state.schema.calculatedFields.step2.area_floor_plate = areaFloorPlate;
    // },
    setStep1: (state, Step1) => {
      state.schema.inputs.step1 = Step1;
    },
    setStep2: (state, Step2) => {
      state.schema.inputs.step2 = Step2;
    },
    setStep3A: (state, Step3A) => {
      state.schema.inputs.step3A = Step3A;
    },
    setStep3B: (state, Step3B) => {
      state.schema.inputs.step3B = Step3B;
    },
    setStep3C: (state, Step3C) => {
      state.schema.inputs.step3C = Step3C;
    },
    setStep4: (state, Step4) => {
      state.schema.inputs.step4 = Step4;
    },
    setStep5A: (state, Step5A) => {
      state.schema.inputs.step5A = Step5A;
    },
    setStep5B: (state, Step5B) => {
      state.schema.inputs.step5B = Step5B;
    },
    setRetv6A: (state, Retv6A) => {
      state.schema.inputs.retv6A = Retv6A;
    },
    setRetv6B: (state, Retv6B) => {
      state.schema.inputs.retv6B = Retv6B;
    },
    setRetv6C: (state, Retv6C) => {
      state.schema.inputs.retv6C = Retv6C;
    },
  },
  actions: {
    setSchema: ({ commit }, schema) => {
      commit('setSchema', schema);
    },
    setProjects: ({ commit }, projects) => {
      commit('setProjects', projects);
    },
    setActiveProject: ({ commit }, activeProject) => {
      commit('setActiveProject', activeProject);
    },
    setShadings: ({ commit }, shadings) => {
      commit('setShadings', shadings);
    },
    setStep1: ({ commit }, Step1) => {
      commit('setStep1', Step1);
    },
    setStep2: ({ commit }, Step2) => {
      commit('setStep2', Step2);
    },
    setStep3A: ({ commit }, Step3A) => {
      commit('setStep3A', Step3A);
    },
    setStep3B: ({ commit }, Step3B) => {
      commit('setStep3B', Step3B);
    },
    setStep3C: ({ commit }, Step3C) => {
      commit('setStep3C', Step3C);
    },
    setStep4: ({ commit }, Step4) => {
      commit('setStep4', Step4);
    },
    setStep5A: ({ commit }, Step5A) => {
      commit('setStep5A', Step5A);
    },
    setStep5B: ({ commit }, Step5B) => {
      commit('setStep5B', Step5B);
    },
    setRetv6A: ({ commit }, Retv6A) => {
      commit('setRetv6A', Retv6A);
    },
    setRetv6B: ({ commit }, Retv6B) => {
      commit('setRetv6B', Retv6B);
    },
    setRetv6C: ({ commit }, Retv6C) => {
      commit('setRetv6C', Retv6C);
    },
  },

  getters: {
    getSchema: state => {
      state.schema;
    },
    getProjects: state => {
      state.projects;
    },

    getActiveProject: state => {
      state.activeProject;
    },
    getShadings: state => {
      state.shadings;
    },
    // getLocations: state => {
    //   state.projectLocations;
    // },
    // getRoofConstructionData: state => {
    //   state.roofConstruction;
    // },
    // getWallConstructionData: state => {
    //   state.wallConstruction;
    // },
    // getStep5B: state => {
    //   state.schema.inputs.step5B;
    // },
  },
  // plugins: [vuexLocal.plugin],
  modules: {},
});
